"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableCellValueIntegerProperty = exports.resultsTableCellValueIntegerPropertyDefinition = void 0;
exports.resultsTableCellValueIntegerPropertyDefinition = {
    view: { label: 'Results Table Cell Value Integer' },
    constraints: [
        {
            name: 'pattern',
            argument: '^([0-9]*|DNF)$',
        },
    ],
    type: 'text',
    multiple: false,
    name: 'results-table-cell-value-integer',
};
const isResultsTableCellValueIntegerProperty = (prop) => {
    return prop.name === exports.resultsTableCellValueIntegerPropertyDefinition.name;
};
exports.isResultsTableCellValueIntegerProperty = isResultsTableCellValueIntegerProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1jZWxsLXZhbHVlLWludGVnZXIucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9yZXN1bHRzLXRhYmxlLWNlbGwtdmFsdWUtaW50ZWdlci5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDhDQUE4QyxHQUFHO0lBQzVELElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxrQ0FBa0MsRUFBRTtJQUNuRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxTQUFTO1lBQ2YsUUFBUSxFQUFFLGdCQUFnQjtTQUMzQjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxrQ0FBa0M7Q0FDVCxDQUFBO0FBSTFCLE1BQU0sc0NBQXNDLEdBQUcsQ0FBQyxJQUFrQixFQUFnRCxFQUFFO0lBQ3pILE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxzREFBOEMsQ0FBQyxJQUFJLENBQUE7QUFDMUUsQ0FBQyxDQUFBO0FBRlksUUFBQSxzQ0FBc0MsMENBRWxEIn0=